export const zhCN = {
  app: {
    title: '小屋与花田',
    loading: '正在整理花田……',
    loadFailed: '存档加载失败',
    retry: '重试',
  },
  audio: {
    open: '声音设置',
    title: '声音设置',
    description: '声音会在首次点击或触摸页面后播放。',
    music: '背景音乐音量',
    sfx: '游戏音效音量',
    close: '完成',
    saveFailed: '声音设置保存失败，本次调整可能无法保留。',
  },
} as const;
